import { Theme, styled } from '@material-ui/core';

export const MessageWrapper = styled('div')<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  border: theme.config.defaultBorder(theme.palette.grey[300]),
  padding: theme.spacing(1, 2),
}));

export const MessageDetailsLine = styled('div')<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));
